import { useMutation } from '@tanstack/react-query';
import { registerTenantService } from 'TenantModule/services';
import {
  RegisterServiceToTenantFailureResponse,
  RegisterServiceToTenantPayload,
  RegisterServiceToTenantSuccessResponse,
} from 'TenantModule/types';
import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useNotification } from 'hooks/useNotification';

export const useTenantRegisterService = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<RegisterServiceToTenantSuccessResponse>,
    AxiosResponse<RegisterServiceToTenantFailureResponse>,
    RegisterServiceToTenantPayload
  >({
    // may need to improve in the future, may need invalidate
    mutationKey: ['registerTenantService'],
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return registerTenantService({ params, token });
    },
    onSuccess: (data) => {
      // ✅ FIX: Replace alert() with toast notification
      showSuccess('Register service to tenant successful!');
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Register service to tenant failed! ${error.data.message}`);
    },
  });
  return {
    registerTenantService: mutation.mutate,
    isRegisteringServiceToTenant: mutation.isPending,
  };
};
